import {ActionTree} from "vuex";
import {EventProfileState, EventProfile} from "./model";
import {RootStateType} from "@/store";
import {AxiosResponse} from "axios";

const actions: ActionTree<EventProfileState, RootStateType> = {
  findList({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].get('/event_profiles', {params: params})
        .then((response: AxiosResponse) => {
          const eventProfiles: EventProfile[] = response.data;
          commit('setEventProfiles', eventProfiles);
          return eventProfiles;
        });
  },
  create({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].post('/event_profiles', params)
        .then((response: AxiosResponse) => {
          const eventProfile: EventProfile = response.data;
          commit('addEventProfile', eventProfile);
          return eventProfile;
        });
  },
  update({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].patch(`/event_profiles/${params.id}`, params)
        .then((response: AxiosResponse) => {
          const eventProfile: EventProfile = response.data;
          commit('updateEventProfile', eventProfile);
          return eventProfile;
        });
  },
  delete({rootGetters, commit}, id) {
    return rootGetters['hcs/client'].delete(`/event_profiles/${id}`)
        .then((response: AxiosResponse) => {
          commit('deleteEventProfile', id);
        });
  }
}

export default actions;
